import { ConceptoPartida } from "./concepto";

export interface CargaDocumentosRequest {
  codigos_recepcion?: Array<string>;
  list_ids_crs?: Array<number>;
  id_orden_compra?: any;
  xml_base64?: string;
  pdf_base64?: string;
  concepto_partidas: Array<ConceptoPartida>;
}

export class CargaDocumentosRequestAnticipo {
  codigos_recepcion?: Array<string>;
  list_ids_crs?: Array<number>;
  id_orden_compra?: any;
  xml_base64?: string;
  pdf_base64?: string;
  concepto_partidas?: Array<ConceptoPartida>;
}